import { SiteControlWidget } from '@scaleaq/sitecontrol-lib';

import { DEFAULT_LAYOUT_GRID_COLUMNS } from '@/pages/landingPage/constants/defaultGridItemSizeAndPosition.ts';

import {
  findFirstAvailableGridPosition,
  type GridWidgetPlacement,
} from './findFirstAvailableGridPosition.ts';
import { getNewWidget, type GetNewWidgetProps } from './getNewWidget.ts';

type GetNewWidgetForLayoutAppendProps = GetNewWidgetProps & {
  existingWidgets: GridWidgetPlacement[];
  numColumns?: number;
  w: number;
  h: number;
  /** When set, keeps the replaced widget's grid cell (empty-placeholder flow). */
  replacingWidget?: GridWidgetPlacement;
};

/**
 * Creates a widget ready to append to a layout.
 * Reuses the replaced cell when replacing a placeholder; otherwise first free cell (reading order).
 */
export const getNewWidgetForLayoutAppend = ({
  componentName,
  defaultWidgetConfig,
  existingWidgets,
  h,
  layoutId,
  numColumns = DEFAULT_LAYOUT_GRID_COLUMNS,
  replacingWidget,
  siteId,
  w,
}: GetNewWidgetForLayoutAppendProps): SiteControlWidget => {
  const base = getNewWidget({
    componentName,
    defaultWidgetConfig,
    layoutId,
    siteId,
  });

  const { x, y } = replacingWidget
    ? { x: replacingWidget.x ?? 0, y: replacingWidget.y ?? 0 }
    : findFirstAvailableGridPosition({ existingWidgets, w, h, numColumns });

  return { ...base, w, h, x, y };
};
